export const CONTENT_WIDTH = "1200px";
